// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__26sDG","question":"Question_question__3gyjN","description":"Question_description__1vdvZ"};